import { myPlaneusModules } from "../enums/modules"

export const LOCALSTORAGE_STARTPAGE_KEY = "planeo.startPage"
export const LOCALSTORAGE_CHANGELOGS_KEY = "planeo.changeLogs"

interface Role {
  roleId: number
  roleName: string
}

interface ModuleLicence {
  moduleLicenceId: number
  id: string
  moduleLicenceName: string
  licenceId: number
  maxNumberOfUsers: number
  isMenu: boolean
  isLicence: boolean
  siteSequence: number
  expiryDate?: Date
  usersAssigned: number
  areas: object[]
  role: Role
}

interface ModuleArea {
  moduleLicenceId: number
  id: string
  moduleLicenceName: string
  moduleLicences: ModuleLicence[]
}

export const initialModulesAreas: ModuleArea[] = [
  {
    moduleLicenceId: 20,
    id: "myplaneus",
    moduleLicenceName: "My planeus",
    moduleLicences: [
      {
        moduleLicenceId: 21,
        id: myPlaneusModules.userinfo,
        moduleLicenceName: "User info",
        licenceId: 0,
        maxNumberOfUsers: 0,
        isMenu: true,
        isLicence: false,
        siteSequence: 1,
        expiryDate: null,
        usersAssigned: 1,
        areas: [],
        role: {
          roleId: 1,
          roleName: "Admin",
        },
      },
      {
        moduleLicenceId: 22,
        id: myPlaneusModules.modulepreferences,
        moduleLicenceName: "Module Preferences",
        licenceId: 0,
        maxNumberOfUsers: 0,
        isMenu: true,
        isLicence: false,
        siteSequence: 1,
        expiryDate: null,
        usersAssigned: 1,
        areas: [],
        role: {
          roleId: 1,
          roleName: "Admin",
        },
      },
      {
        moduleLicenceId: 222,
        id: myPlaneusModules.languages,
        moduleLicenceName: "Languages",
        licenceId: 0,
        maxNumberOfUsers: 0,
        isMenu: true,
        isLicence: false,
        siteSequence: 1,
        expiryDate: null,
        usersAssigned: 1,
        areas: [],
        role: {
          roleId: 1,
          roleName: "Admin",
        },
      },
    ],
  },
]
